module.exports = __webpack_public_path__ + "static/media/icon-mail.2892c3a6.svg";